import {
  stringLatinCharactersAndQuotes,
  validatePhoneNumber,
  email,
} from '../../../../../Utils/Validators/formValidation'
import { validPassword } from '../../../../../shared/validation'
import { checkIfUserExist } from '../../../../Auth/SignUp/graphQL'
import { isPersonalEmail } from '../../../../../Utils/EmailValidation'
import { EDDM_SIGNUP } from '../../../../../shared/constants'

export const allowedExtensions = ['jpg', 'jpeg', 'png']
export const maxFileSize = 5 * 1024 * 1024 // 5MB in bytes
export const maxImageWidth = 1000
export const maxImageHeight = 1000

export const PROFILE_FORM_INPUTS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PHONE: 'mobilePhone',
  EMAIL: 'email',
  PICTURE: 'profilePicture',
  ROLE: 'role',
  PASSWORD: 'password',
  PASSWORD2: 'password2',
}

export const requiredFields = [
  'firstName',
  'lastName',
  'mobilePhone',
  'role',
  'password',
  'password2',
  'email',
]

const validationPassMessage =
  'Minimum 8 characters, one lower case, one upper case, one number.'

const NAME_FIELDS = {
  [PROFILE_FORM_INPUTS.FIRST_NAME]: 'First name',
  [PROFILE_FORM_INPUTS.LAST_NAME]: 'Last name',
}

export const validateUserProfile = async (
  e,
  setErrors,
  errors,
  userData,
  checkUserTimeout,
  setCheckUserTimeout,
  setCheckingEmail,
  client,
) => {
  if (
    !e ||
    !e.target.name ||
    (!e.target.value && e.target.name !== PROFILE_FORM_INPUTS.ROLE)
  ) {
    return
  } else if (
    [PROFILE_FORM_INPUTS.FIRST_NAME, PROFILE_FORM_INPUTS.LAST_NAME].includes(
      e.target.name,
    )
  ) {
    setErrors({
      ...errors,
      [e.target.name]:
        stringLatinCharactersAndQuotes(e.target.value) ||
        (e.target.value.length < 2
          ? `${NAME_FIELDS[e.target.name]} must contain at least 2 letters`
          : undefined),
    })
  } else if ([PROFILE_FORM_INPUTS.PHONE].includes(e.target.name)) {
    setErrors({
      ...errors,
      [e.target.name]: validatePhoneNumber(e.target.value),
    })
  } else if ([PROFILE_FORM_INPUTS.EMAIL].includes(e.target.name)) {
    const newEmail = e.target.value
    const emailError = email(newEmail)
    if (emailError) {
      setErrors({ ...errors, [e.target.name]: emailError })
    } else {
      if (checkUserTimeout) {
        clearTimeout(checkUserTimeout)
      }

      if (client.createdBy !== EDDM_SIGNUP && isPersonalEmail(newEmail)) {
        setErrors({ ...errors, [e.target.name]: 'Please enter a work email' })
        return
      }

      setCheckingEmail(true)

      const onCheckExistUser = setTimeout(
        async email => {
          const response = await checkIfUserExist(email)
          const {
            data: { isExistUser },
          } = await response.json()
          setErrors({
            ...errors,
            email: isExistUser
              ? 'An account with this email already exists.'
              : null,
          })
          setCheckingEmail(false)
        },
        500,
        newEmail,
      )
      setCheckUserTimeout(onCheckExistUser)
    }
  } else if (
    [PROFILE_FORM_INPUTS.PASSWORD, PROFILE_FORM_INPUTS.PASSWORD2].includes(
      e.target.name,
    )
  ) {
    const errorMessage = validPassword(e.target.value, {
      minLength: validationPassMessage,
      minLowercase: validationPassMessage,
      minUppercase: validationPassMessage,
      minNumber: validationPassMessage,
    })
    if (errorMessage) {
      setErrors({ ...errors, [e.target.name]: errorMessage })
      return
    }
    if (PROFILE_FORM_INPUTS.PASSWORD === e.target.name) {
      if (e.target.value !== userData[PROFILE_FORM_INPUTS.PASSWORD2]) {
        setErrors({
          ...errors,
          [PROFILE_FORM_INPUTS.PASSWORD]:
            'Your password and confirmation password do not match.',
          [PROFILE_FORM_INPUTS.PASSWORD2]:
            'Your password and confirmation password do not match.',
        })
      } else {
        setErrors({
          ...errors,
          [PROFILE_FORM_INPUTS.PASSWORD]: null,
          [PROFILE_FORM_INPUTS.PASSWORD2]: null,
        })
      }
    } else {
      if (e.target.value !== userData[PROFILE_FORM_INPUTS.PASSWORD]) {
        setErrors({
          ...errors,
          [PROFILE_FORM_INPUTS.PASSWORD]:
            'Your password and confirmation password do not match.',
          [PROFILE_FORM_INPUTS.PASSWORD2]:
            'Your password and confirmation password do not match.',
        })
      } else {
        setErrors({
          ...errors,
          [PROFILE_FORM_INPUTS.PASSWORD]: null,
          [PROFILE_FORM_INPUTS.PASSWORD2]: null,
        })
      }
    }
  } else if ([PROFILE_FORM_INPUTS.ROLE].includes(e.target.name)) {
    setErrors({
      ...errors,
      [e.target.name]: !e.target.value ? 'User must have a role' : null,
    })
  }
}

export const handleImageUpdate = ({
  event,
  setUserData,
  userData,
  setProfilePicture,
}) => {
  const fileUploaded = event.target.files[0]

  if (fileUploaded) {
    const fileExtension = fileUploaded.name
      .split('.')
      .pop()
      .toLowerCase()
    const isValidExtension = allowedExtensions.includes(fileExtension)

    if (!isValidExtension) {
      alert('Invalid file extension')
      return
    }

    if (fileUploaded.size > maxFileSize) {
      alert('File size exceeds the limit of 5MB.')
      return
    }

    const img = new Image()
    const objectUrl = URL.createObjectURL(fileUploaded)

    img.onload = function() {
      if (this.width > maxImageWidth || this.height > maxImageHeight) {
        alert('Image size exceeds the limit of 1000 x 1000px.')
        return
      }

      setUserData({ ...userData, [PROFILE_FORM_INPUTS.PICTURE]: fileUploaded })
      setProfilePicture(objectUrl)
    }
    img.src = objectUrl
  }
}
